import React, { useEffect } from 'react';
import { analytics, MODAL_CLOSED_EVENT, MODAL_OPENED_EVENT } from '../../../../helpers/analytics';
import { useTranslation } from 'react-i18next';
import { Button } from '../../actions/button/button';
import { Modal, ModalControlProps } from '../modal';

type AbandonSessionProps = {
	onAbandon: () => void;
	onDismiss: () => void;
} & ModalControlProps;

export const AbandonSession = ({ open, onOpenChange, onAbandon, onDismiss }: AbandonSessionProps) => {
	const { t } = useTranslation();
	const properties = { title: 'Abandon Session Modal' };

	const handleOpenChange = (open: boolean) => {
		if (!open) {
			analytics.track(MODAL_CLOSED_EVENT, properties);
		}
		onOpenChange(open);
	};

	const handleDismiss = () => {
		analytics.track(MODAL_CLOSED_EVENT, properties);
		onDismiss();
	};

	useEffect(() => {
		if (open) {
			analytics.track(MODAL_OPENED_EVENT, properties);
		}
	}, [open]);

	return (
		<Modal open={open} onOpenChange={handleOpenChange}>
			<Modal.Header closeModal={handleDismiss}>{t('checkout.modals.abandon_session.title')}</Modal.Header>

			<Modal.Body>
				<p>{t('checkout.modals.abandon_session.description1')}</p>
				<p>{t('checkout.modals.abandon_session.description2')}</p>
			</Modal.Body>

			<Modal.Footer>
				<Button fullWidth variant='destructive' onClick={onAbandon}>
					{t('checkout.modals.abandon_session.button')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
